module.exports = __webpack_public_path__ + "img/gbwhatsapp-screen-3.94d8556a.webp";